import * as React from 'react';
import { Control } from 'react-redux-form';

import { CheckboxInline } from '@common/components';
import { PaymentType } from '@models/Payment';

export interface PaymentTypeFormControlsComponentProperties {
  readonly isDemandLetterEnabled: boolean;
  readonly modelPathPrefix: string;
  readonly paymentType: PaymentType;
  readonly setPaymentType: (paymentType: PaymentType) => void;
  readonly isNegativePayment?: boolean;
  readonly isBalancePayment?: boolean;
}

export function PaymentTypeFormControlsComponent(props: PaymentTypeFormControlsComponentProperties): JSX.Element {
  return (
    <>
      {!props.isNegativePayment && (
        <CheckboxInline>
          <Control
            checked={props.paymentType === PaymentType.CreditCard}
            id={props.modelPathPrefix.concat('.creditCard')}
            model={props.modelPathPrefix}
            name={props.modelPathPrefix}
            onChange={e => props.setPaymentType(PaymentType.CreditCard)}
            value={PaymentType.CreditCard}
            type="radio"
          />
          <label htmlFor={props.modelPathPrefix.concat('.creditCard')}>Credit Card</label>
        </CheckboxInline>
      )}
      {props.isBalancePayment && (
        <CheckboxInline>
          <Control
            checked={props.paymentType === PaymentType.ACH}
            id={props.modelPathPrefix.concat('.ach')}
            model={props.modelPathPrefix}
            name={props.modelPathPrefix}
            onChange={() => props.setPaymentType(PaymentType.ACH)}
            value={PaymentType.ACH}
            type="radio"
          />
          <label htmlFor={props.modelPathPrefix.concat('.ach')}>ACH Transfer</label>
        </CheckboxInline>
      )}
      {props.isDemandLetterEnabled && (
        <CheckboxInline>
          <Control
            checked={props.paymentType === PaymentType.DemandLetter}
            id={props.modelPathPrefix.concat('.demandLetter')}
            model={props.modelPathPrefix}
            name={props.modelPathPrefix}
            onChange={() => props.setPaymentType(PaymentType.DemandLetter)}
            value={PaymentType.DemandLetter}
            type="radio"
          />
          <label htmlFor={props.modelPathPrefix.concat('.demandLetter')}>Demand Letter</label>
        </CheckboxInline>
      )}
    </>
  );
}



// WEBPACK FOOTER //
// ./src/payment/_components/payment-type-form-controls.component.tsx